import type { NotificationApiItem, NotificationsResponse } from '../types';
import { getNotificationHref } from './notification-navigation';
import { getNotificationTrackingProperties } from './notification-tracking';
import type { HeaderNotificationItem } from './notification-types';

function formatNotificationDate(
  createdAt: string,
  currentTime: string,
  timezone: string
) {
  const created = new Date(createdAt);
  const current = new Date(currentTime);

  if (Number.isNaN(created.getTime())) return createdAt;
  if (Number.isNaN(current.getTime()))
    return created.toLocaleDateString('vi-VN', { timeZone: timezone });

  const minutes = Math.max(
    0,
    Math.floor((current.getTime() - created.getTime()) / 60_000)
  );

  if (minutes < 1) return 'Vừa xong';
  if (minutes < 60) return `${minutes} phút trước`;
  if (minutes < 24 * 60) return `${Math.floor(minutes / 60)} giờ trước`;

  return created.toLocaleDateString('vi-VN', { timeZone: timezone });
}

export function normalizeNotification(
  item: NotificationApiItem,
  response: NotificationsResponse
): HeaderNotificationItem {
  const content = item.content;
  const href = getNotificationHref(item);
  const message =
    content.body?.vi || content.title?.vi || content.title?.name || '';
  const group = response.meta.groups.find(entry => entry.id === item.groupId);

  return {
    id: item.id,
    message,
    date: formatNotificationDate(
      item.createdAt,
      response.meta.currentTime,
      response.meta.timezone
    ),
    category: content.actionName || 'Thông báo',
    group: group?.id || item.groupId,
    avatarSrc: content.imageUrl || content.data?.imageUrl,
    fallbackInitial: (
      content.data?.fullName ||
      content.title?.vi ||
      content.title?.name ||
      'U'
    )
      .replaceAll('**', '')
      .charAt(0)
      .toUpperCase(),
    href,
    trackingProperties: getNotificationTrackingProperties(item, href),
    unread: item.status !== 'read',
  };
}

export function getNotificationItems(response: NotificationsResponse) {
  if (Array.isArray(response.data)) return response.data;
  if (response.meta.total === 0) return [];

  throw new Error('Dữ liệu thông báo chưa đúng định dạng.');
}
